<template>
    <footer class="content">
        <router-link to="/" class="text-normal no-underline">
            &copy; {{ currentYear }} Revolution Plus Property Ltd.
        </router-link>
        <strong class="text-black d-block d-sm-inline"> All Rights Reserved</strong>
    </footer>    
</template>

<script>
export default {
    name: "Footer",
    computed: {
        currentYear() {
            return new Date().getFullYear()   
        }
    }
}
</script>

<style scoped>
.content {
    background: #ece5ec;
    margin: 0 -50px;
    padding: 15px 0;
    position: relative;
}
</style>